export default __webpack_public_path__ + "static/media/phylactere_mijn_broertjes.3ad15449.png";